angular
    .module('empower.lodgeClaim')
    .directive('lodgeClaimHistory', ['lodgeClaimService', '$rootScope', 'commonConst',
        function (lodgeClaimService, $rootScope, commonConst) {
            return {
                restrict: 'E',
                templateUrl: 'module/lodgeClaim/view/lodge-claim-history.html',
                scope: true,
                controller: function ($scope) {
                    $scope.isClaimant = $rootScope.user.IsClaimant;
                    $scope.rowSelections = commonConst.ROWS_PER_PAGE_ITEMS;             
                    $scope.rowPerPage = 10;
                    $scope.searchTotalResult = 0;
                    $scope.searchPageSelected = 1;
                    $scope.paging = {
                        index: 1
                    }

                    $scope.$on('reloadLodgeClaimHistoryHistory', function (event, params) {
                        if (params.policyId) {
                            $scope.policyId = params.policyId;                           
                            $scope.searchPageSelected = 1;
                            $scope.getLodgeClaimHistory(1);

                        } else {
                            clearHistories();
                        }
                    }); // reloadUploadDocumentHistory

                    $scope.getLodgeClaimHistory = function (pageNumber) {
                        // save page number
                        $scope.searchPageSelected = pageNumber || 1;

                        lodgeClaimService.getLodgeClaimHistory({
                            PolicyId: $scope.policyId,
                            RowsPerPage: $scope.rowPerPage || commonConst.ROWS_PER_PAGE,
                            PageNumber: pageNumber || 1

                        }).then(function (response) {
                            $scope.LodgeClaimHistories = response.Data;
                            $scope.searchTotalResult = response.RowsCount;
                            $scope.HistoryPages = _.range(1, response.PageCount + 1);
                        });
                    }; // getLodgeClaimHistory

                    var clearHistories = function () {
                        $scope.LodgeClaimHistories = [];
                        $scope.searchTotalResult = 0;
                        $scope.HistoryPages = [];
                    }
                    $scope.selectRow = function(rowPerPage) {
                        $scope.rowPerPage = rowPerPage;
                        $scope.searchPageSelected = 1;
                        $scope.getLodgeClaimHistory(1);
                    }
                }, // controller
                link: function (scope, element, attrs) {} // link
            };
        }
    ])